<!-- <div>
  <ets-header [headerState]="HEADER_STATES.SIGN_UP"></ets-header>
  <div class="outer-div">
      <router-outlet></router-outlet>
  </div>
</div> -->

<ets-header [headerState]="HEADER_STATES.LOGO_ONLY" [isBGWhite]="true"></ets-header>
<router-outlet></router-outlet>